"use strict";

exports.__esModule = true;
exports["default"] = exports.StyledRawHtml = exports.Html = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["colorScheme", "htmlTextColor", "includeStyles"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledRawHtml = (0, _styledComponents["default"])(function (_ref) {
  var colorScheme = _ref.colorScheme,
      htmlTextColor = _ref.htmlTextColor,
      includeStyles = _ref.includeStyles,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, props);
}).withConfig({
  displayName: "html__StyledRawHtml",
  componentId: "sc-19rpb3o-0"
})(["a{border-bottom:none;color:", ";text-decoration:underline;", " &:hover{color:", ";}}em{font-style:italic;}strong{font-weight:700;}sub{bottom:-0.25em;font-size:80%;font-weight:400;position:relative;vertical-align:sub;}sup{font-size:50%;vertical-align:super;font-weight:400;position:relative;top:-0.6em;}h1,h2,h3,h4,h5,h6,p{margin:0;}h2,h3{font-weight:600;}h4,h5,h6{font-weight:700;}h1{font-size:", "px;line-height:", ";margin-bottom:", "px;}h2{font-size:", "px;line-height:", ";margin-bottom:", "px;", " ", "}h3{font-size:", "px;line-height:", ";margin-bottom:", "px;margin-top:", "px;", "}h4{font-size:", "px;line-height:", ";margin-bottom:", "px;margin-top:", "px;}h5{font-size:", "px;line-height:", ";margin-bottom:", "px;margin-top:", "px;}h6{font-size:", "px;line-height:", ";margin-bottom:", "px;}p{margin-bottom:", "px;&:last-child{margin-bottom:0;}}ul{list-style:disc;padding-left:", "px;margin-bottom:", "px;}ol{padding-left:", "px;margin-bottom:", "px;list-style:none;counter-reset:my-awesome-counter;li{counter-increment:my-awesome-counter;&::before{content:counter(my-awesome-counter) \". \";color:", ";font-weight:700;left:-16px;display:inline-block;top:0;position:absolute;}}}li{padding-left:", "px;position:relative;strong{color:", ";}margin-bottom:", "px;}hr{background:", ";border:none;clear:both;height:2px;margin-top:", "px;margin-bottom:", "px;&:last-child > &:last-child{margin-bottom:0;}}", ";"], function (_ref2) {
  var colorScheme = _ref2.colorScheme,
      theme = _ref2.theme;
  return (0, _styles.colors)(colorScheme, {
    theme: theme
  });
}, (0, _styles.defaultTransition)(["color"]), function (_ref3) {
  var colorScheme = _ref3.colorScheme,
      theme = _ref3.theme;
  return (0, _styles.themeDarken)(0.15, colorScheme, {
    theme: theme
  });
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes[12];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeights[1];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings[2];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes[11];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeights[1];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacings[2];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (min-width:", "px) and (max-width:", "px){font-size:", "px;letter-spacing:-0.5px;}"], theme.breakpointInts[2], theme.breakpointInts[2], theme.fontSizes[10]) : null;
}, function (_ref11) {
  var theme = _ref11.theme;
  return (0, _utils.makeMediaQuery)(theme.breakpointInts[1], "max", "\n      font-size: " + theme.fontSizes[8] + "px;\n    ");
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes[8];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.lineHeights[1];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacings[2];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacings[5];
}, function (_ref16) {
  var theme = _ref16.theme;
  return (0, _utils.makeMediaQuery)(theme.breakpointInts[0], "max", "\n      font-size: " + theme.fontSizes[6] + "px;\n      line-height: " + theme.lineHeights[2] + ";\n    ");
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSizes[6];
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.lineHeights[2];
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.spacings[2];
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.spacings[5];
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontSizes[4];
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.lineHeights[2];
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.spacings[1];
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.spacings[5];
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontSizes[3];
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.lineHeights[2];
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.spacings[1];
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.spacings[2];
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.spacings[3];
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.spacings[2];
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.spacings[3];
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.spacings[2];
}, function (props) {
  return (0, _styles.colors)("text-title", props);
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.spacings[1];
}, function (props) {
  return (0, _styles.colors)("text-title", props);
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.spacings[2];
}, function (props) {
  return (0, _styles.colors)("gray-divider", props);
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.spacings[4];
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.spacings[4];
}, function (_ref37) {
  var colorScheme = _ref37.colorScheme,
      htmlTextColor = _ref37.htmlTextColor,
      includeStyles = _ref37.includeStyles,
      theme = _ref37.theme;
  return includeStyles ? (0, _styledComponents.css)(["color:", ";font-size:", "px;line-height:", ";font-weight:400;a{color:", ";text-decoration:underline;", " &:hover{color:", ";}}h2,h3,h4,h5,h6{color:", ";}ul{list-style:disc;padding-left:", "px;margin-bottom:", "px;}ol{padding-left:", "px;margin-bottom:", "px;list-style:none;counter-reset:my-awesome-counter;li{counter-increment:my-awesome-counter;&::before{content:counter(my-awesome-counter) \". \";color:", ";font-weight:700;left:-16px;display:inline-block;top:0;position:absolute;}}}li{padding-left:", "px;position:relative;strong{color:", ";}}hr{background:", ";border:none;clear:both;height:2px;margin-top:", "px;margin-bottom:", "px;&:last-child > &:last-child{margin-bottom:0;}}"], (0, _styles.colors)(htmlTextColor, {
    theme: theme
  }), theme.fontSizes[4], theme.lineHeights[3], (0, _styles.colors)("text-link", {
    theme: theme
  }), (0, _styles.defaultTransition)(["color"]), (0, _styles.themeDarken)(0.15, "text-link", {
    theme: theme
  }), (0, _styles.colors)(colorScheme === "white" ? colorScheme : "text-title", {
    theme: theme
  }), theme.spacings[3], theme.spacings[2], theme.spacings[3], theme.spacings[2], (0, _styles.colors)("text-title", {
    theme: theme
  }), theme.spacings[1], (0, _styles.colors)("text-title", {
    theme: theme
  }), (0, _styles.colors)("gray-divider", {
    theme: theme
  }), theme.spacings[4], theme.spacings[4]) : null;
});
exports.StyledRawHtml = StyledRawHtml;
var propTypes = {
  /** Container class name */
  className: _propTypes.string,

  /** color from the color scheme */
  colorScheme: _propTypes.string,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** html text color */
  htmlTextColor: _propTypes.string,

  /** boolean to include styles  */
  includeStyles: _propTypes.bool,

  /** theme object */
  theme: _utils.themePropType,

  /** html value */
  value: _propTypes.string
};

var Html = function Html(_ref38) {
  var colorScheme = _ref38.colorScheme,
      className = _ref38.className,
      dataTestId = _ref38["data-test-id"],
      htmlTextColor = _ref38.htmlTextColor,
      includeStyles = _ref38.includeStyles,
      theme = _ref38.theme,
      value = _ref38.value;
  return /*#__PURE__*/_react["default"].createElement(StyledRawHtml, {
    className: className,
    colorScheme: colorScheme,
    "data-test-id": dataTestId,
    html: value,
    htmlTextColor: htmlTextColor,
    includeStyles: includeStyles,
    theme: theme
  });
};

exports.Html = Html;
Html.propTypes = propTypes;
Html.displayName = "Modules.Html";
var _default = Html;
exports["default"] = _default;